import { render, staticRenderFns } from "./file3.vue?vue&type=template&id=280cf860&scoped=true&"
import script from "./file3.vue?vue&type=script&lang=js&"
export * from "./file3.vue?vue&type=script&lang=js&"
import style0 from "./file3.vue?vue&type=style&index=0&id=280cf860&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280cf860",
  null
  
)

export default component.exports